import { ApplicationState } from "application/redux";
import { connect } from "react-redux";
import DeviceChecksComponent from "./device-checks-component";

const mapStateToProps = (state: ApplicationState) => ({
  general: state.devices.detail.general,
  offset: state.application.offset
})

export default connect(mapStateToProps)(DeviceChecksComponent)
